"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.flattenType = void 0;
const isObject_1 = require("./isObject");
const flattenType = (input) => {
    const result = {};
    function flattenObject(source, target, topLevelKey = '') {
        for (const nestedKey in source) {
            if (Object.prototype.hasOwnProperty.call(source, nestedKey)) {
                const value = source[nestedKey];
                const newKey = topLevelKey ? `${topLevelKey}.${nestedKey}` : nestedKey;
                if ((0, isObject_1.isObjectType)(value)) {
                    flattenObject(value, target, newKey);
                }
                else {
                    target[newKey] = value;
                }
            }
        }
    }
    flattenObject(input, result);
    return result;
};
exports.flattenType = flattenType;
//# sourceMappingURL=flattenType.js.map